module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('peopleHeader')], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('VShowCell', {
    attrs: {
      "typeIcon": "A",
      "title": "我的信息"
    }
  }, [_c('p', {
    staticClass: "two"
  }, [_vm._v("通知")]), _vm._v(" "), _c('p', {
    staticClass: "two",
    domProps: {
      "textContent": _vm._s(_vm.record)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "message"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0593f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TeacherInfo.vue
// module id = 763
// module chunks = 1